// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2j8M2","options":"AnswerScale_options__212gj","selected":"AnswerScale_selected__3fwbg"};